<template>
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" width="220" height="80">
      <svg class="dimension" :class="{unscored: score==-1}">
        <text y="16" x="18" class="heading">{{dimension}}</text>
        <svg x="18" y="28" @click="updateScore(0)" :class="{score: score==0}">
          <polygon points="26 2 12 2 2 12 2 26 12 36 26 36 36 26 36 12 26 2"></polygon>
          <text y="25" x="14">0</text>
        </svg>
        <svg x="51" y="28" @click="updateScore(1)" :class="{score: score==1}">
          <circle cx="19" cy="19" r="18"></circle>
          <text x="14" y="25">1</text>
        </svg>
        <svg x="84" y="28" @click="updateScore(2)" :class="{score: score==2}">
          <circle cx="19" cy="19" r="18"></circle>
          <text y="25" x="14">2</text>
        </svg>
        <svg x="117" y="28" @click="updateScore(3)" :class="{score: score==3}">
          <circle cx="19" cy="19" r="18" x="115"></circle>
          <text y="25" x="14">3</text>
        </svg>
        <svg x="149" y="28" @click="updateScore(5)" :class="{score: score==5}">
          <path
            d="M 29 1.011 C 35.627 1.011 41 6.824 41 13.994 C 41 17.312 39.85 20.34 37.957 22.635 L 37.971 22.65 L 37.485 23.175 C 37.485 23.175 37.485 23.175 37.485 23.175 L 21 41.011 L 4.515 23.175 C 4.515 23.175 4.515 23.175 4.515 23.175 L 4.029 22.65 L 4.043 22.635 C 2.15 20.34 1 17.312 1 13.994 C 1 6.824 6.373 1.011 13 1.011 C 16.067 1.011 18.865 2.256 20.986 4.304 L 21 4.289 L 21.014 4.304 C 23.135 2.256 25.933 1.011 29 1.011 Z"
          ></path>
          <text y="25" x="15.5">5</text>
        </svg>
      </svg>
    </svg>
  </div>
</template>

<script>
export default {
  data() {
    return {
      testValue: -1
    }
  },
  props: {
    dimension: {
      type: String,
      required: true
    },
    score: {
      type: Number,
      required: true
    },
    judgingOpen: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    log(msg) {
      console.log(msg)
    },
    updateScore(score) {
      if (this.judgingOpen) {
        let payload = {
          dimension: this.dimension,
          doc: this.$route.params.ceid,
          value: score,
          currentJudge: this.$store.state.currentUser
        }
        // console.log(payload)
        this.$store.dispatch('judging/updateScore', payload)
      }
    }
  },
  mounted() {
    // console.log(this.dimension, this.score)
  }
}
</script>

<style lang="scss">
svg.dimension.unscored {
  path,
  circle,
  polygon {
    stroke-width: 1;
    stroke-opacity: 1;
    stroke: white;
    fill: #343a40;
  }
}

svg.dimension {
  path,
  circle,
  polygon {
    stroke-width: 0;
    stroke-opacity: 0;
    stroke: transparent;
    fill: transparent;
  }
  cursor: pointer;
  text {
    font-weight: 200;
    stroke-width: 0;
    stroke-opacity: 1;
    stroke: none;
    fill: white;
  }
  .heading {
    font-size: 0.9em;
  }
  svg:hover {
    path,
    circle,
    polygon {
      stroke-width: 1;
      stroke-opacity: 1;
      fill: #23272b;
      stroke: #1d2124;
    }
  }
  svg.score {
    path,
    circle,
    polygon {
      fill: white;
    }
    text {
      fill: #343a40;
    }
  }
}
</style>
